import ApplicationDetailsCard from "../../components/ApplicationDetailsCard";
// import ApplicationDetailsData from "../../components/ApplicationdetailData";
import { performanceData, statsData, educators, students } from "../../components/ApplicationdetailData";
import StatCard from "../../components/StatCard";
import ClassPerformanceChart from "../../components/ClassPerformanceChart";
import ManageEducatoresUser from "../../components/ManageEducatoresUser";
import ApplicationDetailStudentsTable from "../../components/ApplicationDetailStudentsTable";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import helpers from "../../utils/helpers";
import { applicationService } from "../../services/applicationService";

function ApplicationDetail({ userRole,permission }) {
  let params = useParams()
  const [applicationDetail, setApplicationDetail] = useState([])
  const [applicationStudent, setApplicationStudent] = useState([])
  const [applicationEducator, setApplicationEducator] = useState([])
  const [applicationMonthlyUsage, setApplicationMonthlyUsage] = useState([])
  const [applicationStats, setApplicationStats] = useState([])
  const [allData, setallData] = useState([])
  const [loader, setLoader] = useState(false)
  let decryptId = helpers.decryptId(params.id)

  useEffect(() => {
    getApplicationDetail()
  }, [decryptId])

  async function getApplicationDetail() {
    try {
      setLoader(true)
      let data = JSON.stringify({
        id: decryptId
      })
      const response = await applicationService.getApplicationById(data)
      if (response?.success == true) {
        setLoader(false)
        setApplicationDetail(response?.data?.application)
        setApplicationStudent(response?.data?.students)
        setApplicationEducator(response?.data?.Educator)
        setApplicationMonthlyUsage(response?.data?.graph)
        setApplicationStats(response?.data?.stats)
        setallData(response?.data)
      } else {
        setLoader(false)
        setApplicationDetail([])
        setApplicationStudent([])
        setApplicationEducator([])
        setApplicationMonthlyUsage([])
        setApplicationStats([])
      }
    } catch (e) {
      setLoader(false)
      throw e
    }
  }
  const handleExport = () => {
    if (!allData) {
      alert('No data available to export');
      return;
    }

    const csvSections = [];

    // Helper: Convert array → CSV
    const convertArrayToCSV = (data, sectionName) => {
      if (!data || !data.length) return '';
      const headers = Object.keys(data[0]);
      const rows = data.map(row =>
        headers.map(h => `"${(row[h] ?? '').toString().replace(/"/g, '""')}"`).join(',')
      );
      return `\n\n"${sectionName.toUpperCase()}"\n${headers.join(',')}\n${rows.join('\n')}`;
    };

    // Helper: Convert object → single-row CSV
    const convertObjectToCSV = (obj, sectionName) => {
      if (!obj || Object.keys(obj).length === 0) return '';
      const headers = Object.keys(obj);
      const values = headers.map(h => `"${(obj[h] ?? '').toString().replace(/"/g, '""')}"`);
      return `\n\n"${sectionName.toUpperCase()}"\n${headers.join(',')}\n${values.join(',')}`;
    };

    // 1️⃣ Application (single object)
    if (allData.application && Object.keys(allData.application).length > 0) {
      csvSections.push(convertObjectToCSV(allData.application, 'Application'));
    }

    // 2️⃣ Students (array)
    if (Array.isArray(allData.students) && allData.students.length > 0) {
      csvSections.push(convertArrayToCSV(allData.students, 'Students'));
    }

    // 3️⃣ Educator (array)
    if (Array.isArray(allData.Educator) && allData.Educator.length > 0) {
      csvSections.push(convertArrayToCSV(allData.Educator, 'Educators'));
    }

    // 4️⃣ Graph (array)
    if (Array.isArray(allData.graph) && allData.graph.length > 0) {
      csvSections.push(convertArrayToCSV(allData.graph, 'Graph'));
    }

    // 5️⃣ Stats (array of small objects)
    if (Array.isArray(allData.stats) && allData.stats.length > 0) {
      csvSections.push(convertArrayToCSV(allData.stats, 'Stats'));
    }

    // Combine all CSV sections
    const finalCSV = csvSections.join('\n');

    // Trigger CSV Download
    const blob = new Blob([finalCSV], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `application_export_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Application Details</h1>
        <p className="text-gray-600">View application information and launch</p>
      </div>


      <div>
        {/* <ApplicationModal isOpen={true} onClose={() => {}} onSave={(data) => console.log(data)} application={null} /> */}

        <ApplicationDetailsCard userRole={userRole} applicationDetail={applicationDetail} getApplicationDetail={getApplicationDetail} handleExport={handleExport} permission={permission}/>
      </div>

      <div className="card">
        <div className="card-body">
          <h2 className="text-lg font-semibold mb-4">Usage & Metric</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">

            {statsData.map((stat, index) => {
              const appStat = applicationStats[index];
              return (
                appStat && (
                  <StatCard
                    key={stat.id || index}
                    icon={stat.icon}
                    title={appStat.title}
                    value={appStat.value}
                    arrowColor={stat.arrowColor}
                    link={stat.link}
                  />
                )
              );
            })}

          </div>


          <div className="grid md:grid-cols-2 gap-6  ">
            <div className='p-4'>

              <div className=" mb-4 rounded-lg border border-gray-200 p-3">
                <h2 className="text-lg font-semibold text-[#717576] ">
                  <span className="text-lg font-bold"> Monthly Usage Trends </span> (application launches Over the past 6 month)
                </h2>

                <ClassPerformanceChart data={applicationMonthlyUsage} />
              </div>
            </div>
            <div className='p-3 '>
              <div className=" mb-4 rounded-lg border border-gray-200 p-3">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-gray-700 font-semibold">Educators</h2>
                  {userRole?.role_name == 'Admin' &&
                    <Link to='/management/users'><button className="text-blue-600 text-sm font-medium hover:underline">
                      Manage User
                    </button>
                    </Link>
                  }
                </div>
                <ManageEducatoresUser userRole={userRole} educators={applicationEducator} loader={loader} getApplicationDetail={getApplicationDetail} decryptId={decryptId}/>
              </div>
            </div>


          </div>


        </div>
      </div>




      <div className="card">
        <div className="card-body">
          <h2 className="text-lg font-semibold mb-4 text-gray-500">Students</h2>
          <ApplicationDetailStudentsTable userRole={userRole} students={applicationStudent} loader={loader} getApplicationDetail={getApplicationDetail} decryptId={decryptId}/>
        </div>
      </div>




    </div >
  )
}

export default ApplicationDetail